import React from 'react';
import { Globe, Plus } from 'lucide-react';
import { cn } from '../../utils/cn';

interface EmptyStateProps {
  currentPlan: any;
  sitesCount: number;
  onCreateWebsite: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  currentPlan,
  sitesCount,
  onCreateWebsite,
}) => {
  const isAtLimit = currentPlan && currentPlan.maxSites && sitesCount >= currentPlan.maxSites;

  return (
    <div className="text-center py-16 animate-fade-in">
      <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-gray-100 flex items-center justify-center">
        <Globe className="h-10 w-10 text-gray-400" />
      </div>
      <h3 className="text-xl font-semibold text-gray-900 mb-2">No websites yet</h3>
      <p className="text-gray-600 mb-6 max-w-md mx-auto">
        Get started by creating your first website. Build beautiful, professional sites with our
        drag-and-drop editor.
      </p>
      <button
        onClick={onCreateWebsite}
        disabled={isAtLimit}
        className={cn(
          'btn-primary inline-flex items-center space-x-2',
          isAtLimit && 'opacity-50 cursor-not-allowed'
        )}
      >
        <Plus size={20} />
        <span>Create Your First Website</span>
      </button>
    </div>
  );
};
